<div class="main-field sectionBlock">
  <div class="row">
    <div class="col-md-6 col-lg-6 col-sm-6" style="float: left;">
      <h5 class="listHeaderText ml-2">Bank Account List ({{this.bankAccountData?.length}})</h5>
    </div>
    <div class="col-md-6 col-lg-6 col-sm-6 d-flex" style="justify-content: flex-end;">

      <div class="export d-flex" data-toggle="modal" data-target="#bookingModalRight"
        (click)="changeAddUpdateModalState(null, 'add')">
        <div class="add-actionbutton-icon">
          <img src="../../../../assets/images/addbookingwhite.svg" aria-hidden="true">
        </div>
        <div class="add-actionbutton-text">Add</div>
      </div>
    </div>
  </div>
  <div class="main-block-content">
    <div class="bankList">
      <app-common-table-dark [columnDefs]="columnDefs" [data]="bankAccountData"
        (rowAction)="onRowAction($event)">
      </app-common-table-dark>
    </div>
  </div>
</div>